import {
  getCheckValue,
  getCurrentUi,
  getUrlParamValue,
  isNumber,
} from 'designer/component/action/Data'
import objectPath from 'object-path'
import moment from 'moment'
import {
  checkPropTab,
  createDatasource,
  createInputValue,
} from 'designer/component/action/Api'
import cloneDeep from 'clone-deep'
import { isEmpty } from 'designer/component/action/condition/State'

export const checkExceptRowData = (action, rowData) => {
  let isExcept = false
  let { exceptField } = action
  if (!exceptField) return isExcept
  exceptField.forEach((except) => {
    let { request, exceptEmpty, exceptUndefined } = except
    let value = objectPath.get(rowData, request)
    let isExceptEmpty = isEmpty(value)
    let isExceptUndefined = value === undefined
    if (!exceptEmpty && !exceptUndefined) {
      isExcept = false
    } else if (isExceptEmpty || isExceptUndefined) {
      isExcept = isExceptEmpty || isExceptUndefined
    }
  })
  return isExcept
}

export const checkExceptRequest = (action, requestBody, request, value) => {
  if (requestBody && typeof requestBody === 'object') {
    objectPath.set(requestBody, request, value)
  }
  let { exceptField } = action
  if (!exceptField) return requestBody
  let except = exceptField.find((item) => item.request === request)
  if (!except) return requestBody
  let { exceptEmpty, exceptUndefined } = except
  if (Array.isArray(value)) {
    value = value.filter((itemValue) => {
      if (Object.keys(itemValue).length === 0) return false
      const allEmpty = Object.values(itemValue).every((value) => {
        let isExceptEmpty = isEmpty(value)
        let isExceptUndefined = value === undefined
        if (!exceptEmpty && !exceptUndefined) return false
        return isExceptEmpty || isExceptUndefined
      })
      return !allEmpty
    })
    objectPath.set(requestBody, request, value)
  } else {
    let isExceptEmpty = isEmpty(value)
    let isExceptUndefined = value === undefined
    if (!exceptEmpty && !exceptUndefined) return false
    return isExceptEmpty || isExceptUndefined
  }
  return requestBody
}

export const checkExceptDeleteMode = (mainAction, subAction, value) => {
  let { exceptField } = mainAction
  let { request } = subAction
  if (exceptField) {
    let foundExceptDeleteMode = exceptField.find(
      (item) => item.request === request && item.exceptDeleteMode,
    )
    if (foundExceptDeleteMode) {
      let filterValue = value.filter((item) => {
        return !objectPath.get(item, '@isDeleted')
      })
      return filterValue
    }
  }
  return value
}

export const setRequestFormData = ({
  form,
  data,
  requestBody,
  designContext,
  apiSchema,
}) => {
  let { formData, allParams, user } = data
  let { jsonForm, tabParamActive } = designContext
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  const mapFormData = objectPath.get(jsonForm, 'schema.mapFormData')
  const mapTag = objectPath.get(jsonForm, 'schema.mapTag')
  let {
    jsonKey = '',
    mapParam = {},
    mapOther = {},
    mapArray = {},
    mapWidget = {},
    mapReplace = {},
    isSystem,
    componentName,
    formComponentName,
  } = form

  let isComponentData = !isSystem
  let paramList = Object.keys(mapParam)
  let otherList = Object.values(mapOther)
  let dataObj = objectPath(formData)

  if (isSystem) {
    paramList.forEach((key) => {
      let name = mapParam[key]
      let replaceName = mapReplace[key]
      let dataName = replaceName || name
      let dataKey =
        isComponentData && componentName ? `${componentName}.${name}` : name
      let requestKey = jsonKey ? `${jsonKey}.${dataName}` : dataName
      let value
      let isArray = objectPath.get(mapArray, key)
      let isWidget = objectPath.get(mapWidget, key)

      if (formComponentName) {
        dataKey = `${formComponentName}.${dataKey}`
      }

      if (isWidget) {
        let { itemName, name, isMainDynamic, isDynamic, dynamicName } = isWidget
        if (objectPath.has(formData, name)) {
          if (isMainDynamic) {
            value = objectPath.get(formData, `${name}.${dynamicName}`)
          } else if (isDynamic) {
          } else {
            value = objectPath.get(formData, `${name}.${itemName}`)
          }
        } else {
          if (isMainDynamic) {
            value = objectPath.get(formData, `${dynamicName}`)
          } else if (isDynamic) {
          } else {
            value = objectPath.get(formData, itemName)
          }
        }
        value = convertValueBySchema(apiSchema, requestKey, value)
        requestBody = checkExceptRequest(form, requestBody, requestKey, value)
      } else if (isArray) {
        let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
        if (ui.key === key) {
          let arrayData = []
          let { elements = [], param = [] } = ui
          elements.forEach((mainElement) => {
            let subElements = mainElement.elements
            let arrayObj = {}
            subElements.forEach((subElement) => {
              let { key, name } = subElement
              if (mapFormData[key]) {
                let value =
                  dataObj.get(`@${mainElement.name}.${name}`) ||
                  dataObj.get(key)
                objectPath.set(arrayObj, name, value)
              }
            })
            arrayData.push(arrayObj)
          })
          param.forEach(({ tabKey, name, value }) => {
            let index = elements.findIndex((element) => element.key === tabKey)
            if (index > -1) {
              objectPath.set(arrayData, `${index}.${name}`, value)
            }
          })
          requestBody = checkExceptRequest(
            form,
            requestBody,
            requestKey,
            arrayData,
          )
        }
      } else {
        if (jsonKey) {
          if (dataObj.get(`${key}.${dataKey}`)) {
            value = dataObj.get(`${key}.${dataKey}`)
          } else if (dataObj.get(`${jsonKey}.${dataKey}`)) {
            value = dataObj.get(`${jsonKey}.${dataKey}`)
          } else if (dataObj.get(key)) {
            value = dataObj.get(key)
          } else if (dataObj.get(dataKey)) {
            value = dataObj.get(dataKey)
          }
          value = value ?? dataObj.get(key)
        } else {
          if (formComponentName) {
            value = dataObj.get(dataKey)
          } else {
            value = dataObj.get(key) ?? dataObj.get(dataKey)
          }
        }
        if (value === undefined) {
          value = checkDefaultValue(key, jsonForm, {
            formComponentName,
            designContext,
          })
        } else if (value === 'true') {
          value = true
        } else if (value === 'false') {
          value = false
        } else if (value === 'null') {
          value = null
        } else {
          let isTable = objectPath.get(mapTag, [key]) === 'table'
          if (isTable && value) {
            value.map((item) => {
              objectPath.del(item, 'tableData')
              return item
            })
          }
        }
        value = convertValueBySchema(apiSchema, requestKey, value)
        requestBody = checkExceptRequest(form, requestBody, requestKey, value)
      }
    })
    otherList.forEach(
      ({ name, value, dataType = '', key, jsonKey, tabKey, tabValue = {} }) => {
        let dataKey = jsonKey ? `${jsonKey}.${name}` : name
        let dataValue = value
        if (dataType === 'prop') {
          dataValue = dataObj.get(dataKey)
        } else if (dataType === 'system') {
          let dataKey = jsonKey ? `${jsonKey}.${key}` : key
          dataValue = dataObj.get(dataKey)
        } else if (dataType === 'user') {
          dataValue = objectPath.get(user, 'userId')
        } else if (dataType === 'employeeCode') {
          dataValue = objectPath.get(user, 'employeeCode')
        } else if (dataType === 'urlParam') {
          dataValue = getUrlParamValue(allParams, value, dataKey)
        } else if (dataType === 'tab') {
          let [containerKey, paramName] = value.split('.')
          dataValue = checkPropTab(
            { designContext },
            { containerKey, paramName },
          )
        } else if (dataType === 'custom') {
          if (isNumber(value)) {
            dataValue = Number(value)
          } else if (value === 'true') {
            dataValue = true
          } else if (value === 'false') {
            dataValue = false
          } else if (value === 'null') {
            dataValue = null
          } else {
            dataValue = value
          }
        } else if (dataType === 'dateTime') {
          let now = null
          if (value === 'currentDate') {
            now = moment().format('YYYY-MM-DD')
          } else if (value === 'currentTime') {
            now = moment().format('HH:mm:ss')
          } else if (value === 'currentDateTime') {
            now = moment().format('YYYY-MM-DD HH:mm:ss')
          }
          dataValue = now
        } else if (dataType === 'datasource') {
          dataValue = objectPath.get(datasourceValue, value)
        }
        dataValue = convertValueBySchema(apiSchema, name, dataValue)
        objectPath.set(requestBody, name, dataValue)
      },
    )
  } else {
    let requestKey = form.key
    let value = dataObj.get(requestKey)
    value = convertValueBySchema(apiSchema, requestKey, value)
    requestBody = checkExceptRequest(form, requestBody, requestKey, value)
  }
  return requestBody
}

export const setRequestWidget = ({
  form,
  requestBody,
  data,
  action,
  formData,
  apiSchema,
  jsonForm,
  rowData,
}) => {
  let dataList = action.formData
  let mapParam = form.mapParam
  let formValue = formData

  if (dataList) {
    if (rowData) {
      formValue = rowData
    } else if (form.isGroup) {
      let key = form.key
      let [widgetKey, formKey] = key.split('-')
      if (widgetKey && formKey) {
        let ui = getCurrentUi(widgetKey, jsonForm.schema, jsonForm.uischema)
        if (ui.key === widgetKey) {
          let uiName = ui.name
          formValue = objectPath.get(formData, uiName)
        }
      }
    }
    dataList.forEach((item) => {
      let { request, key, dataType } = item
      if (dataType === 'dynamicData') {
        let value = objectPath.get(formValue, item.value)
        if (item.value === '@isDeleted') {
          if (isEmpty(value)) return
        }
        value = convertValueBySchema(apiSchema, request, value)
        objectPath.set(requestBody, request, value)
      } else if (objectPath.has(mapParam, key)) {
        let name = mapParam[key]
        let value =
          objectPath.get(formValue, key) || objectPath.get(formValue, name)
        if (value === undefined) {
          value = checkDefaultValue(key, jsonForm)
        }
        value = convertValueBySchema(apiSchema, request, value)
        objectPath.set(requestBody, request, value)
      }
    })
  }
  return requestBody
}

export const convertValueBySchema = (
  apiSchema,
  request,
  value,
  action = {},
) => {
  let { isDynamic } = action
  if (isDynamic) {
    let dynamicRequest = action.request
    let dynamicApiSchemas = objectPath.get(
      apiSchema,
      `properties.${dynamicRequest}`,
    )
    if (dynamicApiSchemas) {
      let { items } = dynamicApiSchemas
      let type = objectPath.get(items, `properties.${request}.type`)
      if (type) {
        if (type === 'string') {
          value = value?.toString()
        } else if (type === 'number' || type === 'numeric') {
          value = Number(value)
        }
      } else {
        let splitKey = request.split('.')
        let splitItem = []
        splitKey.forEach((key) => {
          let allOf = objectPath.get(items, `properties.${key}.allOf`)
          if (allOf) {
            splitItem = allOf
          } else {
            let foundAllOf = splitItem.find(({ properties }) =>
              objectPath.get(properties, key),
            )
            if (foundAllOf) {
              let type = objectPath.get(foundAllOf, `properties.${key}.type`)
              if (type === 'string') {
                value = isEmpty(value) ? null : value.toString()
              } else if (type === 'number' || type === 'numeric') {
                value = isEmpty(value) ? null : Number(value)
              }
            }
          }
        })
      }
    }
  } else {
    if (value === undefined || value === null || !apiSchema) {
      return value
    }
    let type =
      objectPath.get(apiSchema, `properties.${request}.type`) ||
      objectPath.get(apiSchema, `${request}.type`)
    if (type === 'string') {
      value = value.toString()
    } else if (type === 'number' || type === 'numeric') {
      value = Number(value)
    }
  }

  return value
}

export const checkDefaultValue = (key, jsonForm, props = {}) => {
  let { ui, formComponentName, designContext = {} } = props
  let { isUiChanged = {} } = designContext

  if (formComponentName) {
    let { tabForm = {} } = isUiChanged
    let tab = objectPath.get(tabForm, formComponentName)
    let { jsonForm } = tab
    ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
  } else {
    ui = ui ?? getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
  }
  if (ui.key !== key) return null
  let { defaultValue } = ui
  if (defaultValue === undefined) return null
  return defaultValue
}

export const createCustomRequest = ({
  mainAction,
  action = {},
  data,
  designContext,
  apiSchema = {},
  isCheckSchema = true,
  rowData,
}) => {
  let {
    request,
    propType,
    value,
    key,
    isDynamic,
    dataKey,
    apiKey,
    systemKey,
    dynamicName,
  } = action
  let {
    formData = {},
    systemData = {},
    user,
    datasourceValue,
    allParams,
  } = data
  let { jsonForm } = designContext
  let dataset = objectPath.get(jsonForm, 'dataset') || []
  let mapTag = objectPath.get(jsonForm, 'schema.mapTag') || []

  if (propType === 'dynamic') {
    value = createDynamicData(
      action,
      formData,
      designContext,
      isCheckSchema,
      apiSchema,
      request,
    )
  } else if (propType !== 'input' && isDynamic) {
    value = objectPath.get(formData, request)
  } else if (propType === 'arrayTable') {
    value = createArrayTable(action, formData, mainAction)
  } else if (propType === 'table') {
    value = createTableRequest(action, rowData || data.rowData)
  } else if (propType === 'multiSelect') {
    let hasMultiSelectValue = Object.prototype.hasOwnProperty.call(
      data,
      'multiSelectValue',
    )
    value = hasMultiSelectValue
      ? data.multiSelectValue
      : createMultiSelectCustomRequest({
          action,
          data,
          designContext,
        })
  } else if (propType === 'autoSeq') {
    value = data.autoSeq
  } else if (propType === 'user') {
    value = objectPath.get(user, 'userId')
  } else if (propType === 'employeeCode') {
    value = objectPath.get(user, 'employeeCode')
  } else if (propType === 'input') {
    value = undefined
    if (dynamicName && objectPath.get(formData, dynamicName)) {
      value = objectPath.get(formData, dynamicName)
    } else if (systemKey && objectPath.get(formData, systemKey)) {
      value = objectPath.get(formData, systemKey)
    } else if (request && objectPath.get(formData, request)) {
      value = objectPath.get(formData, request)
    } else if (key && objectPath.get(formData, key)) {
      value = objectPath.get(formData, key)
    }
    if (value === undefined) {
      value = checkDefaultValue(key || systemKey, jsonForm)
    }
    value = createInputValue(action, value)
  } else if (propType === 'widget') {
    value = createDatasource(action, formData)
  } else if (propType === 'system') {
    value = objectPath.get(systemData, key) || objectPath.get(formData, key)
  } else if (propType === 'urlParam') {
    value = objectPath.get(allParams, key)
  } else if (propType === 'datasource') {
    value = createDatasource(action, datasourceValue)
  } else if (propType === 'response') {
    let valueKey = dataKey ? `${dataKey}.${key}` : key
    value = objectPath.get(formData, `@response.${apiKey}.${valueKey}`)
  } else if (propType === 'dataset') {
    value = createDatasetRequest(dataset, key, formData)
  } else if (propType === 'dateTime') {
    value = createNowRequest(value)
  }
  if (isCheckSchema) {
    value = convertValueBySchema(apiSchema, request, value)
  }
  if (value === 'true') {
    value = true
  } else if (value === 'false') {
    value = false
  } else if (value === 'null') {
    value = null
  } else {
    let isTable = objectPath.get(mapTag, [key]) === 'table'
    if (isTable && Array.isArray(value)) {
      value.map((item) => {
        objectPath.del(item, 'tableData')
        return item
      })
    }
  }
  return value
}

const getApiSchema = ({ apiSchema, name }) => {
  let { type } = apiSchema
  if (type === 'array') {
    let itemsApiSchema = objectPath.get(apiSchema, 'items')
    let subApiSchema = objectPath.get(itemsApiSchema, `properties.${name}`)
    return subApiSchema
  }
  if (type === 'object') {
    let subApiSchema = objectPath.get(apiSchema, `properties.${name}`)
    return subApiSchema
  }
  return apiSchema
}

const convertValueSchema = (apiSchema, name, value) => {
  if (isEmpty(value)) return value
  let { type, oneOf } = apiSchema
  if (oneOf) {
    let foundType = oneOf.find(({ type }) => {
      let isNumberValue = isNumber(value)
      let isNotNumberValue = !isNumber(value)
      if (type === 'number') {
        return isNumberValue
      }
      if (type === 'string') {
        return isNotNumberValue
      }
    })
    type = foundType?.type
  }
  if (type === 'number') {
    return Number(value)
  }
  if (type === 'string') {
    return value.toString()
  }
  return value
}

const createDynamicItem = ({
  dynamicData,
  arrayData,
  formData,
  designContext,
  isCheckSchema,
  apiSchema,
  ui,
}) => {
  let { jsonForm, urlParams } = designContext
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  let { dynamicRequest } = ui
  arrayData.forEach((itemData) => {
    let dynamicItem = {}
    dynamicRequest.forEach(
      ({ valueType, dynamicField, customValue, otherValue, defaultValue }) => {
        if (!dynamicField) return
        if (valueType === 'field') {
          let { key } = dynamicField
          let fieldUi = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
          if (fieldUi.key !== key) return
          let { name } = fieldUi
          let itemValue =
            objectPath.get(itemData, key) || objectPath.get(itemData, name)
          if (fieldUi.tagname === 'dynamic') {
            let subApiSchema = getApiSchema({ apiSchema, name })
            let dynamicValue = createDynamicItem({
              dynamicData: [],
              arrayData: itemValue,
              formData,
              designContext,
              isCheckSchema,
              apiSchema: subApiSchema,
              ui: fieldUi,
            })
            objectPath.set(dynamicItem, name, dynamicValue)
          } else {
            if (itemValue === undefined && !isEmpty(defaultValue)) {
              itemValue = defaultValue
            }
            let subApiSchema = getApiSchema({ apiSchema, name })
            if (isCheckSchema) {
              itemValue = convertValueSchema(subApiSchema, name, itemValue)
            }
            objectPath.set(dynamicItem, name, itemValue)
          }
        } else if (valueType === 'other' && otherValue) {
          let name = dynamicField.value
          let otherKey = otherValue.key
          let otherName = otherValue.value
          let propType = otherValue.groupType
          let value
          if (propType === 'urlParam') {
            value = objectPath.get(urlParams, otherKey)
          } else if (propType === 'datasources') {
            value = objectPath.get(datasourceValue, otherKey)
          } else if (propType === 'response') {
            value = objectPath.get(formData, `@response.${otherKey}`)
          } else {
            value =
              objectPath.get(formData, otherKey) ||
              objectPath.get(formData, otherName)
            if (propType === 'input' && value === undefined) {
              value = checkDefaultValue(otherKey, jsonForm)
            }
          }
          let subApiSchema = getApiSchema({ apiSchema, name })
          if (isCheckSchema) {
            value = convertValueSchema(subApiSchema, name, value)
          }
          objectPath.set(dynamicItem, name, value)
        } else if (valueType === 'custom') {
          let name = dynamicField.value
          let value = customValue
          let subApiSchema = getApiSchema({ apiSchema, name })
          if (isCheckSchema) {
            value = convertValueSchema(subApiSchema, name, value)
          }
          objectPath.set(dynamicItem, name, value)
        }
      },
    )
    dynamicData.push(dynamicItem)
  })
  return dynamicData
}

const createDynamicRequest = ({
  formData,
  designContext,
  isCheckSchema,
  apiSchema,
  ui,
  requestName,
}) => {
  let mainKey = ui.key
  let mainName = ui.name
  let dynamicData = []
  let arrayData =
    objectPath.get(formData, mainKey) ||
    objectPath.get(formData, mainName) ||
    []
  let subApiSchema = objectPath.get(apiSchema, `properties.${requestName}`)
  dynamicData = createDynamicItem({
    dynamicData,
    arrayData,
    formData,
    designContext,
    isCheckSchema,
    apiSchema: subApiSchema,
    ui,
  })
  return dynamicData
}

const createDynamicData = (
  action,
  formData,
  designContext,
  isCheckSchema,
  apiSchema,
  request,
) => {
  let { jsonForm } = designContext
  let uiKey = action.key
  let ui = getCurrentUi(uiKey, jsonForm.schema, jsonForm.uischema)
  if (ui?.dynamicRequest) {
    return createDynamicRequest({
      action,
      formData,
      designContext,
      isCheckSchema,
      apiSchema,
      ui,
      requestName: request,
    })
  } else {
    let { mapKey, mapFormData } = jsonForm.schema
    let filterMapKey = Object.keys(mapKey).filter((key) => {
      let fullKey = mapKey[key]
      let keyList = fullKey.split('.')
      let isIncludeKey = keyList.includes(uiKey)
      let isFormData = mapFormData[key]
      return isIncludeKey && isFormData
    })
    let arrayValue = []
    let dynamicValue = objectPath.get(formData, action.dynamicName)
    if (dynamicValue && Array.isArray(dynamicValue)) {
      dynamicValue.forEach((itemValue) => {
        let requestValue = {}
        filterMapKey.forEach((key) => {
          let item = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
          if (item.key === key) {
            let value =
              objectPath.get(itemValue, item.name) ||
              objectPath.get(itemValue, item.key)
            if (value === undefined) {
              value = convertValueBySchema(apiSchema, item.name, value, action)
            }
            objectPath.set(requestValue, item.name, value)
          }
        })
        if (objectPath.get(itemValue, '@isDeleted')) {
          objectPath.set(requestValue, 'deleteMode', 1)
        }
        arrayValue.push(requestValue)
      })
    }
    return arrayValue
  }
}

const createArrayTable = (subAction, formData, mainAction) => {
  let { dynamicName, subRequest, arrayTableType } = subAction
  let key = subAction.key ? subAction.key : subAction.systemKey
  let tableData =
    objectPath.get(formData, key) || objectPath.get(formData, dynamicName)
  let requestTable = []
  if (!subRequest) return requestTable
  if (!Array.isArray(tableData)) return requestTable
  tableData = checkExceptDeleteMode(mainAction, subAction, tableData)
  if (arrayTableType === 'detailPanel') {
    let { detailPanelKey, detailPanelSelect } = subAction
    tableData.forEach((rowData) => {
      let checkRow = cloneDeep(rowData)
      objectPath.del(checkRow, '@genId')
      objectPath.del(checkRow, '@seq')
      let emptyRow = Object.keys(checkRow).length === 0
      if (emptyRow) return
      if (detailPanelSelect) {
        detailPanelSelect.forEach((item) => {
          let detailPanelKey = item.field
          let subRowData = objectPath.get(rowData, detailPanelKey)
          if (subRowData && Array.isArray(subRowData)) {
            subRowData.forEach((rowData) => {
              let itemRequest = {}
              subRequest.forEach((item) => {
                let rowValue = objectPath.get(rowData, item.value)
                if (item.valueType !== 'string') {
                  rowValue = getCheckValue(rowValue)
                }
                if (rowValue === undefined) {
                  rowValue = item.defaultValue
                }
                objectPath.set(itemRequest, item.request, rowValue)
              })
              if (Object.keys('itemRequest').length > 0) {
                requestTable.push(itemRequest)
              }
            })
          }
        })
      } else if (detailPanelKey) {
        let subRowData = objectPath.get(rowData, detailPanelKey)
        if (subRowData && Array.isArray(subRowData)) {
          subRowData.forEach((rowData) => {
            let itemRequest = {}
            subRequest.forEach((item) => {
              let rowValue = objectPath.get(rowData, item.value)
              if (item.valueType !== 'string') {
                rowValue = getCheckValue(rowValue)
              }
              if (rowValue === undefined) {
                rowValue = item.defaultValue
              }
              objectPath.set(itemRequest, item.request, rowValue)
            })
            if (Object.keys('itemRequest').length > 0) {
              requestTable.push(itemRequest)
            }
          })
        }
      }
    })
  } else {
    tableData.forEach((rowData) => {
      let checkRow = cloneDeep(rowData)
      objectPath.del(checkRow, '@genId')
      objectPath.del(checkRow, '@seq')
      let emptyRow = Object.keys(checkRow).length === 0
      if (emptyRow) return
      let itemRequest = {}
      subRequest.forEach((item) => {
        let rowValue = objectPath.get(rowData, item.value)
        if (item.valueType === 'array') {
          let detailRequest = item.subRequest
          if (rowValue) {
            let rowItemValue = []
            rowValue.forEach((itemValue) => {
              let subItemRequest = {}
              detailRequest.forEach((detail) => {
                let mainColumn = detail.mainColumn
                let requestName = detail.request
                let rowKey = detail.value
                let value
                if (rowKey === 'deleteMode') {
                  value =
                    objectPath.get(itemValue, rowKey) ||
                    objectPath.get(rowData, rowKey)
                } else if (mainColumn) {
                  value = objectPath.get(itemValue, rowKey)
                } else {
                  value = objectPath.get(rowData, rowKey)
                }
                if (value === undefined) {
                  value = objectPath.get(rowData, requestName)
                }
                if (value !== undefined) {
                  objectPath.set(subItemRequest, requestName, value)
                }
              })
              rowItemValue.push(subItemRequest)
            })
            rowValue = rowItemValue
          }
        } else if (item.valueType !== 'string') {
          rowValue = getCheckValue(rowValue)
        }
        if (rowValue !== undefined) {
          objectPath.set(itemRequest, item.request, rowValue)
        }
      })
      if (Object.keys('itemRequest').length > 0) {
        requestTable.push(itemRequest)
      }
    })
  }
  return requestTable
}

const createTableRequest = (action, rowData) => {
  let { key, subRequest } = action
  let mainData = objectPath.get(rowData, key)
  if (subRequest) {
    let newData = []
    subRequest.forEach(({ request, value }) => {
      if (request && value) {
        let subKeyList = checkSubValueKey(value, mainData)
        subKeyList.forEach((key, index) => {
          let value = objectPath.get(mainData, key)
          objectPath.set(newData, `${index}.${request}`, value)
        })
      }
    })
    if (newData.length === 0) {
      mainData = undefined
    } else {
      mainData = newData
    }
  } else {
    let format = action.type
    mainData = getCheckValue(mainData, format)
  }
  return mainData
}

const checkSubValueKey = (valueKey, data) => {
  let noIndex = valueKey.search('#') === -1
  if (noIndex) {
    return [valueKey]
  }
  let newValueKey = valueKey.replace('#', '0')
  let hasValue = objectPath.has(data, newValueKey)
  let subData = cloneDeep(data)
  let requestKeyList = []
  if (hasValue) {
    let keyList = valueKey.split('.')
    keyList.forEach((key) => {
      let hasValue = objectPath.has(subData, key)
      if (hasValue) {
        subData = objectPath.get(subData, key)
      } else {
        if (key === '#') {
          if (Array.isArray(subData)) {
            subData.forEach((subValue, index) => {
              let requestKey = valueKey.replace('#', index)
              requestKeyList.push(requestKey)
            })
          }
        }
      }
    })
  }
  return requestKeyList
}

const createDatasetRequest = (dataset, key, formData) => {
  let value
  let foundDataset = dataset.find((data) => data.key === key)
  if (foundDataset) {
    let datasetValue = []
    let { elementKey, elementName, fields } = foundDataset
    let elementData = objectPath.has(formData, elementKey)
      ? objectPath.get(formData, elementKey)
      : objectPath.get(formData, elementName) || []
    elementData.forEach((rowData, index) => {
      fields.forEach(({ field, valueType, value }) => {
        if (valueType === 'system') {
          let rowValue = objectPath.get(rowData, field)
          objectPath.set(datasetValue, `${index}.${field}`, rowValue)
        } else if (valueType === 'custom') {
          objectPath.set(datasetValue, `${index}.${field}`, value)
        }
      })
    })
    value = datasetValue
  } else {
    value = null
  }
  return value
}

const createNowRequest = (value) => {
  let now = null
  if (value === 'currentDate') {
    now = moment().format('YYYY-MM-DD')
  } else if (value === 'currentTime') {
    now = moment().format('HH:mm:ss')
  } else if (value === 'currentDateTime') {
    now = moment().format('YYYY-MM-DD HH:mm:ss')
  }
  value = now
  return value
}

const getMultiSelectUi = (selectKey, designContext = {}) => {
  let { jsonForm } = designContext
  let selectUi = {}
  if (!selectKey) return selectUi
  if (designContext.getCurrentUi) {
    selectUi = designContext.getCurrentUi(selectKey)
  }
  if (!selectUi?.key && jsonForm?.schema && jsonForm?.uischema) {
    selectUi = getCurrentUi(selectKey, jsonForm.schema, jsonForm.uischema)
  }
  return selectUi || {}
}

const getMultiSelectValueKey = (selectUi = {}) =>
  selectUi.optionValueKey ||
  objectPath.get(selectUi, [selectUi.optionType, 'optionValue']) ||
  objectPath.get(selectUi, [selectUi.valueType, 'optionValue']) ||
  'value'

const getMultiSelectValueList = (selectUi = {}, formData = {}) => {
  let valueKey = selectUi.key
  let valueName = selectUi.name
  let datasourceKey = valueKey ? `@${valueKey}` : ''
  let datasourceName = valueName ? `@${valueName}` : ''
  let selectValue

  if (datasourceKey && objectPath.has(formData, datasourceKey)) {
    selectValue = objectPath.get(formData, datasourceKey)
  } else if (datasourceName && objectPath.has(formData, datasourceName)) {
    selectValue = objectPath.get(formData, datasourceName)
  } else if (valueKey && objectPath.has(formData, valueKey)) {
    selectValue = objectPath.get(formData, valueKey)
  } else if (valueName && objectPath.has(formData, valueName)) {
    selectValue = objectPath.get(formData, valueName)
  }

  if (selectUi.valueType === 'string' && typeof selectValue === 'string') {
    if (!selectValue) return []
    return selectUi.valueJoin
      ? selectValue.split(selectUi.valueJoin)
      : [selectValue]
  }
  if (Array.isArray(selectValue)) {
    return selectValue.filter((value) => !isEmpty(value))
  }
  if (isEmpty(selectValue)) return []
  return [selectValue]
}

const getMultiSelectOptionValue = (selectUi = {}, option) => {
  let optionValueKey = getMultiSelectValueKey(selectUi)
  if (option && typeof option === 'object') {
    if (optionValueKey && objectPath.has(option, optionValueKey)) {
      return objectPath.get(option, optionValueKey)
    }
    if (objectPath.has(option, 'value')) {
      return objectPath.get(option, 'value')
    }
    if (objectPath.has(option, 'label')) {
      return objectPath.get(option, 'label')
    }
  }
  return option
}

const createMultiSelectRowData = (selectUi = {}, option, optionValue) => {
  if (option && typeof option === 'object') {
    return { ...option, '@value': optionValue }
  }
  let optionValueKey = getMultiSelectValueKey(selectUi)
  return {
    [optionValueKey]: optionValue,
    value: optionValue,
    '@value': optionValue,
  }
}

const createMultiSelectValue = ({
  rowData,
  optionValue,
  optionValueKey,
  seq,
  subRequest,
}) => {
  let itemRequest = {}
  subRequest.forEach(({ request, value, valueType, defaultValue }) => {
    if (!request || !value) return
    let rowValue = value === 'seq' ? seq : objectPath.get(rowData, value)
    if (
      rowValue === undefined &&
      (value === 'value' || value === '@value' || value === optionValueKey)
    ) {
      rowValue = optionValue
    }
    if (rowValue === undefined) {
      rowValue = defaultValue
    }
    if (valueType !== 'string') {
      rowValue = getCheckValue(
        rowValue,
        valueType === 'number' ? 'number' : undefined,
      )
    }
    if (rowValue !== undefined) {
      objectPath.set(itemRequest, request, rowValue)
    }
  })
  return itemRequest
}

const createMultiSelectCustomRequest = ({
  action,
  data,
  designContext,
}) => {
  let { formData = {} } = data
  let { key, systemKey, subRequest = [] } = action
  let selectUi = getMultiSelectUi(key || systemKey, designContext)
  let selectValueList = getMultiSelectValueList(selectUi, formData)
  let requestList = []
  let seq = 1
  let optionValueKey = getMultiSelectValueKey(selectUi)

  selectValueList.forEach((option) => {
    let optionValue = getMultiSelectOptionValue(selectUi, option)
    let rowData = createMultiSelectRowData(selectUi, option, optionValue)
    if (subRequest.length === 0) {
      requestList.push(optionValue)
      return
    }
    let itemRequest = createMultiSelectValue({
      rowData,
      optionValue,
      optionValueKey,
      seq,
      subRequest,
    })
    if (Object.keys(itemRequest).length > 0) {
      requestList.push(itemRequest)
      seq += 1
    }
  })

  return requestList
}

export const createMultiSelectRequest = ({
  action,
  data,
  designContext,
  apiSchema = {},
  isCheckSchema = true,
}) => {
  let { formData = {} } = data
  let { customData = [], selectKey, jsonTableKey, isCreateOnly, refId } = action
  let selectUi = getMultiSelectUi(selectKey, designContext)
  let selectValueList = getMultiSelectValueList(selectUi, formData)
  let arrayRequest = []
  let seq = 1

  selectValueList.forEach((option) => {
    if (isCreateOnly && refId && option && typeof option === 'object') {
      let refValue = objectPath.get(option, refId)
      if (!isEmpty(refValue)) return
    }

    let optionValue = getMultiSelectOptionValue(selectUi, option)
    let rowData = createMultiSelectRowData(selectUi, option, optionValue)
    let itemRequest = {}

    customData.forEach((subAction) => {
      let { request } = subAction
      let value = createCustomRequest({
        mainAction: action,
        action: subAction,
        data: { ...data, rowData, multiSelectValue: optionValue, autoSeq: seq },
        rowData,
        designContext,
        apiSchema,
        isCheckSchema,
      })
      if (value !== undefined) {
        if (request === 'seq') {
          objectPath.set(itemRequest, request, seq)
        } else {
          objectPath.set(itemRequest, request, value)
        }
      }
    })

    let isExcept = checkExceptRowData(action, itemRequest)
    if (!isExcept) {
      arrayRequest.push(itemRequest)
      seq += 1
    }
  })

  if (jsonTableKey) {
    let requestData = {}
    objectPath.set(requestData, jsonTableKey, arrayRequest)
    return requestData
  }

  return arrayRequest
}
